import React, { FC, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import { setDeDataStore } from 'src/fetch/data/store';
import { gridOption } from './gridOption';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxData: FC<Props> = ({ data }) => {
  const dataSet = {};
  const setData = data;
  const totalCount = 1;
  const bindStateData = setDeDataStore(state => state.bindData);
  const optionSet: any = gridOption(setData, totalCount, bindStateData);
  const stateOption: any = {
    label: optionSet.label || [],
    data: optionSet.data || [],
    styleDef: optionSet.styleDef,
    rowStyleDef: { height: '45px' },
    totalCount,
  };

  const pageInfo = {
    current: 1,
    totalCount: totalCount,
    size: 5,
    viewCount: 5,
  };
  const rowClickEvt = () => {};
  const pagingClick = () => {};
  const sortClickEvt = () => {};

  return (
    <div className="_step_d_creditcard_data">
      <div className="_content">
        <div className="_grid_div">
          <TableGrid
            gridOption={stateOption}
            rowClickEvt={rowClickEvt}
            pagingClick={pagingClick}
            sortClickEvt={sortClickEvt}
            dataType="object"
            viewType="type2"
          />
        </div>
      </div>
    </div>
  );
};

export default HomeTaxData;
